import React, { useEffect, useState } from 'react'
import './header.css'
import Wave from '../wave/Wave'
import { useTour } from '../tour/TourContext'
import slide_1 from '../../assets/girl_10.JPG'
import slide_2 from '../../assets/sandbox_large.JPG'
import slide_3 from '../../assets/kids_3.JPG'
import penelope_gif from '../../assets/Logo Waving.gif'
import nac_logo from '../../assets/NAC Logo.png'

const SLIDES = [
  { src: slide_1, alt: 'Girl blowing bubbles' },
  { src: slide_2, alt: 'Children playing in the sandbox' },
  { src: slide_3, alt: 'Children drawing' },
]

const BUBBLES = [
  { size: 90, left: '4%', top: '22%', delay: '0s' },
  { size: 46, left: '44%', top: '14%', delay: '1.5s' },
  { size: 130, left: '86%', top: '10%', delay: '0.8s' },
  { size: 60, left: '52%', top: '70%', delay: '2.2s' },
  { size: 38, left: '8%', top: '78%', delay: '3s' },
]

export default function Header() {
  const { openVideo, openRequest } = useTour()
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const id = setInterval(() => setCurrent((c) => (c + 1) % SLIDES.length), 5000)
    return () => clearInterval(id)
  }, [])

  return (
    <section className="hero">
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="hero-bubble"
          aria-hidden="true"
          style={{ width: b.size, height: b.size, left: b.left, top: b.top, animationDelay: b.delay }}
        />
      ))}

      <div className="hero-inner">
        <div className="hero-copy">
          <span className="section-eyebrow">Learning anchored by movement</span>
          <h1>
            Where little ones <span className="hero-highlight">learn in motion</span>
          </h1>
          <p>
            A unique blend of Montessori and traditional teaching for children from 1 year old
            through pre-kindergarten, in the heart of Tamarac.
          </p>
          <div className="hero-actions">
            <button type="button" className="btn btn-pink" onClick={openRequest}>
              Schedule a Tour
            </button>
            <button type="button" className="btn btn-outline" onClick={openVideo}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">
                <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-2 14.5v-9l7 4.5-7 4.5Z" />
              </svg>
              Watch the Virtual Tour
            </button>
          </div>
          <ul className="hero-facts">
            <li>Open 6:30am – 6:30pm</li>
            <li>Free 4-hour VPK</li>
          </ul>

          <div className="hero-accreditation">
            <img
              src={nac_logo}
              alt="Accredited by the National Accreditation Commission for Early Care and Education Programs"
            />
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-photo">
            {SLIDES.map((s, i) => (
              <img
                key={s.src}
                src={s.src}
                alt={s.alt}
                className={i === current ? 'visible' : ''}
              />
            ))}
          </div>
          <img className="hero-hippo" src={penelope_gif} alt="Penelope the hippo waving hello" />
        </div>
      </div>

      <Wave color="var(--cream)" />
    </section>
  )
}
